import React from 'react';
import { useTranslation } from 'react-i18next';
import type { SaleStatus } from '@/api/saleApi';

interface SaleStatusBadgeProps {
  status: SaleStatus;
}

const SaleStatusBadge: React.FC<SaleStatusBadgeProps> = ({ status }) => {
  const { t } = useTranslation();
  const isPaid = status === 'PAID';

  return (
    <span className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 font-label-sm ${isPaid ? 'bg-success-container text-success' : 'bg-error-container text-error'}`}>
      <span className="material-symbols-outlined text-[16px]" aria-hidden="true">
        {isPaid ? 'check_circle' : 'cancel'}
      </span>
      {t(`admin.sales_history.status.${status.toLowerCase()}`)}
    </span>
  );
};

export default SaleStatusBadge;
